import { render, staticRenderFns } from "./manageIndex.vue?vue&type=template&id=cbe0b40c&scoped=true"
import script from "./manageIndex.vue?vue&type=script&lang=js"
export * from "./manageIndex.vue?vue&type=script&lang=js"
import style0 from "./manageIndex.vue?vue&type=style&index=0&id=cbe0b40c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe0b40c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbe0b40c')) {
      api.createRecord('cbe0b40c', component.options)
    } else {
      api.reload('cbe0b40c', component.options)
    }
    module.hot.accept("./manageIndex.vue?vue&type=template&id=cbe0b40c&scoped=true", function () {
      api.rerender('cbe0b40c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataAccess/questionnaire/manageIndex.vue"
export default component.exports